import React, { ComponentProps, FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { EditableListFormShowTemplate, EditableListDataGridLayout } from 'framework/list';

type GetTableCells = ComponentProps<typeof EditableListDataGridLayout>['getTableCells'];

interface PredecessorSectionProps {
  title: string;
  listSource: string;
  isEmpty: boolean;
  getTableCells: GetTableCells;
  note?: ReactNode;
}

const PredecessorSection: FC<PredecessorSectionProps> = ({ title, listSource, isEmpty, getTableCells, note }) => (
  <Box>
    <Typography variant="h6" color="primary" mb={1}>
      {title}
    </Typography>
    {note && (
      <Typography color="textSecondary" variant="body2" display="inline-block" mb={1}>
        {note}
      </Typography>
    )}
    {isEmpty ? (
      <Typography color="textSecondary" ml={2}>
        Data not found
      </Typography>
    ) : (
      <EditableListFormShowTemplate listSource={listSource}>
        <EditableListDataGridLayout
          disabledAddNewRow
          getRowEnabled={() => true}
          rowProps={{ px: 0 }}
          getTableCells={getTableCells}
        />
      </EditableListFormShowTemplate>
    )}
  </Box>
);

export default PredecessorSection;
